import axios from "axios";

// import { adminStore } from '../store';
// import {
//   INCREASE_REQUEST,
//   DECREASE_REQUEST
// } from '../actions/admin_action_types';

//export const host = 'http://192.168.1.107'; //local
// export const host = 'http://104.43.223.23'; //affle dev
// export const host = 'http://35.247.132.150'; // client uat
// export const host = 'https://liquorappdevapi.affle.com'; // client uat
export const host = ""; // For localhost
// export const host = "http://192.168.2.234"
// export const host = 'http://liquorapp.affle.com'; // client uat

//export const host = 'http://10.28.32.11'; // client prod1 11
// export const host = 'http://10.28.32.12'; // client prod2 12

// export const port = 3016;
// export const port= 3005;
// export const domain = `${host}:${port}`;
export const domain = `${host}`;
// export const domain = `${host}:${port}`;

export const setData = (key, data) => {
  localStorage.setItem(key, JSON.stringify(data));
};

export const getData = key => {
  const data = JSON.parse(localStorage.getItem(key));
  return data ? data : null;
};

export const removeData = key => {
  localStorage.removeItem(key);
};

export const deleteUserData = () => {
  localStorage.clear();
};

export const axiosInstnace = axios.create({
  baseURL: domain
});

// axiosInstnace.interceptors.request.use(
//   config => {
//     if (adminStore) {
//       adminStore.dispatch({ type: INCREASE_REQUEST })
//     }
//     var newconfig = config
//     if (getData('adminData')) {
//       newconfig['headers']['Authorization'] = `Bearer ${getData('adminData').authToken}`
//     }
//     return newconfig;
//   },
//   error => Promise.reject(error)
// )

// axiosInstnace.interceptors.response.use(
//   response => {
//     if (adminStore) {
//       adminStore.dispatch({ type: DECREASE_REQUEST })
//     }
//     return response;
//   },
//   error => {
//     if (adminStore) {
//       adminStore.dispatch({ type: DECREASE_REQUEST })
//     }
//     return {
//       status: 500,
//       data: {
//         message: 'Internal error, sorry for inconvenience, please try again later'
//       }
//     }
//   }
// )

export const isAuthenticated = () => !!getData("adminData");

export const editProductKey = [
  "catName",
  "categories",
  "image",
  "isDeleted",
  "status",
  "__v"
];

export const checkAddProductRequiredFiels = dataObj => {
  for (let data in dataObj) {
    if (dataObj[data] === "") {
      return {
        check: true,
        field: data
      };
    }
  }
  return {
    check: false
  };
};

export const checkUpdateProductRequiredFiels = dataObj => {
  for (let data in dataObj) {
    if (dataObj[data] === "" && editProductKey.indexOf(data) === -1) {
      return {
        check: true,
        field: data
      };
    }
  }
  return {
    check: false
  };
};

export const editImageKey = [
  "approved",
  "created_at",
  "isDeleted",
  "reject",
  "status",
  "updated_at",
  "__v"
];

export const checkUpdateImageRequiredFiels = dataObj => {
  for (let data in dataObj) {
    if (dataObj[data] === "" && editImageKey.indexOf(data) === -1) {
      return {
        check: true,
        field: data
      };
    }
  }
  return {
    check: false
  };
};

export const getDateFormat = date => {
  let year = new Date(date).getFullYear();
  let month = new Date(date).getMonth() + 1;
  let day = new Date(date).getDate();

  month = month.toString().length === 2 ? month : `0${month}`;
  day = day.toString().length === 2 ? day : `0${day}`;

  let fullDate = `${year}-${month}-${day}`;
  return fullDate;
};

export const getEndDateFormat = date => {
  var currentDate = new Date(new Date(date).getTime() + 24 * 60 * 60 * 1000);
  let year = currentDate.getFullYear();
  let month = currentDate.getMonth() + 1;
  let day = currentDate.getDate();

  month = month.toString().length === 2 ? month : `0${month}`;
  day = day.toString().length === 2 ? day : `0${day}`;

  let fullDate = `${year}-${month}-${day}`;
  return fullDate;
};

export const privigesContentNameArr = [
  "Page Title 1",
  "Page Title 1 [Header1]",
  "Page Title 1 [Description1 - Listing]",
  "Page Title 1 [Description1 - Detail View]",
  "Page Title 1 [Promotion Text 1]",
  "Page Title 1 [Promotion Date 1]",
  "Page Title 1 [Header2]",
  "Page Title 1 [Description2 - Listing]",
  "Page Title 1 [Description2 - Detail View]",
  "Page Title 1 [Promotion Text 2]",
  "Page Title 1 [Promotion Date 2]",
  "Page Title 1 [Header3]",
  "Page Title 1 [Description3 - Listing]",
  "Page Title 1 [Description3 - Detail View]",
  "Page Title 1 [Promotion Text 3]",
  "Page Title 1 [Promotion Date 3]",
  "Page Title 1 [Header4]",
  "Page Title 1 [Description4 - Listing]",
  "Page Title 1 [Description4 - Detail View]",
  "Page Title 1 [Promotion Text 4]",
  "Page Title 1 [Promotion Date 4]",
  "Page Title 2",
  "Page Title 2 [Header1]",
  "Page Title 2 [Promotion Text 1]",
  "Page Title 2 [Promotion Date 1]",
  "Page Title 2 [Header2]",
  "Page Title 2 [Promotion Text 2]",
  "Page Title 2 [Promotion Date 2]",
  "Page Title 2 [Header3]",
  "Page Title 2 [Promotion Text 3]",
  "Page Title 2 [Promotion Date 3]",
  "Page Title 2 [Header4]",
  "Page Title 2 [Promotion Text 4]",
  "Page Title 2 [Promotion Date 4]"
];

// oneSignal



// WEBPACK FOOTER //
// ./src/utils/util.js